export default __webpack_public_path__ + "static/logo-869cc9171da1ffa1019e7580b3b50d2d.png";